
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"calendar-a","d":"M3.75 5.25h10.5a.75.75 0 110 1.5H3.75a.75.75 0 010-1.5zm1.553 8.355v-.87l1.762-1.83c.307-.315.532-.622.532-.93 0-.33-.21-.555-.562-.555-.367 0-.63.24-.772.57L5.25 9.398c.338-.78 1.043-1.148 1.77-1.148.938 0 1.777.615 1.777 1.672 0 .63-.337 1.17-.817 1.65l-.87.878h1.763v1.155h-3.57zM13.5 1.5h3c.827 0 1.5.622 1.5 1.39v12.222c0 .766-.673 1.388-1.5 1.388h-15c-.827 0-1.5-.622-1.5-1.388V2.889C0 2.122.673 1.5 1.5 1.5h3V.75a.75.75 0 011.5 0v.75h6V.75a.75.75 0 111.5 0v.75zm0 1.5v.75a.75.75 0 11-1.5 0V3H6v.75a.75.75 0 01-1.5 0V3h-3v12h15V3h-3zm-.09 8.655v1.11h-.525v.84H11.67v-.84H9.285v-1.11l1.672-3.3h1.29l-1.672 3.3h1.095V10.53h1.215v1.125h.525z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"calendar-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#calendar-a"}})]),_c('use',{attrs:{"fill":"#8C99AD","xlink:href":"#calendar-a"}}),_c('g',{attrs:{"fill":"#8C99AD","mask":"url(#calendar-b)"}},[_c('path',{attrs:{"d":"M-3-4h24v24H-3z"}})])])])
          )
        }
      }
    